<template>
  <div class="tooltip-element ml-2">
    <img
      :src="require('@/assets/img/icons/' + src)"
      :height="`${height}`"
      :width="`${width}`"
      v-b-tooltip.hover
      :title="`${title}`"
      :class="`${classname}`"
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    height: {
      type: String,
      default: "20",
    },
    width: {
      type: String,
      default: "20",
    },
    src: {
      type: String,
      default: "question.svg",
    },
    classname: {
      type: String,
      default: ""
    }
  },
};
</script>

<style>

.tooltip-element {
    cursor: pointer;
}
 
</style>



// WEBPACK FOOTER //
// src/components/UIElements/Tooltip.vue